import * as React from 'react';
import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { body1, heading4 } from 'ui/theme/typography';
import { pxToRem } from 'utils/convert';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${pxToRem(400)};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${pxToRem(461)};
`;

export const PlaceholderTitle = styled.div`
  ${heading4};
  color: ${colors.textPrimary};
  margin-bottom: ${spacing.half};
`;

export const PlaceholderDescription = styled.div`
  ${body1};
  text-align: center;
  color: ${colors.textSecondary};
`;

type PlaceholderStateProps = {
  title: string;
  children: React.ReactNode;
  Illustration: React.ComponentType<any>;
} & React.HTMLAttributes<HTMLDivElement>;

export const PlaceholderState = ({
  title,
  children,
  Illustration,
  ...rest
}: PlaceholderStateProps) => (
  <Container data-test="placeholder-state" {...rest}>
    <Content>
      {Illustration && <Illustration />}
      {title && <PlaceholderTitle data-test="placeholder-state-title">{title}</PlaceholderTitle>}
      {children && (
        <PlaceholderDescription data-test="placeholder-state-content">
          {children}
        </PlaceholderDescription>
      )}
    </Content>
  </Container>
);
